var listeRessources = {
  revenus_activite: {
    label: "Revenus d'activité",
    name: 'revenus_activite',
    question: "un revenu d'activité ?",
    questionConjoint : "Votre conjoint perçoit-il un revenu d'activité ?",
    info : 'Concernant votre salaire (dont prime et indemnité de fin de contrat), indiquez les montants nets AVANT prélèvement à la source ou d\'éventuelles saisies.',
    ressources: [
      { name: 'salaire_net', label: 'Salaire net avant prélèvement à la source',single :'un salaire', value: null },
      { name: 'ppa', label: "Prime d'activité",single:'une prime d\'activité', value: null },
      { name: 'revenus_stage_formation_pro', label: 'Revenu de stage de formation professionnelle',single:'un revenu de formation professionnelle', value: null },
      { name: 'indemnites_stage', label: 'Remuneration de stage',single:'une rémuneration de stage', value: null }
    ],
    floorAt : 1
  },

  allocations: {
    name: 'allocations',
    label: 'Allocations',
    question: 'des allocations ?',
    questionConjoint : 'Votre conjoint perçoit-il des allocations ?',
    info : 'Si vous percevez des allocations chômage, indiquez les montants nets AVANT prélèvement à la source ou d\'éventuelles saisies.',
    ressources: [
      { name: 'aide_logement', label: 'Aides au logement (APL, ALS, ALF) ',single:'une aide au logement (apl, als, alf)', value: null, floorAt:1 },
      { name: 'aah', label: 'Allocation adultes handicapés (AAH) ',single:'une allocation adulte handicapé (aah)', value: null },
      { name: 'aspa', label: 'Allocation de solidarité aux personnes âgées (ASPA) ',single:'une allocation de solidarité aux personnes âgées (aspa)', value: null },
      { name: 'ass', label: 'Allocation de solidarité spécifique (ASS) ', single:'une allocation de solidarité spécifique (ass) ',value: null },
      { name: 'asf', label: 'Allocation de soutien familial (ASF) ', single:'une allocation de soutien familial (asf)',value: null },
      {
        name: 'allocation_securisation_professionnelle',
        label: 'Allocation de sécurisation professionnelle ',
        single:'une allocation de sécurisation professionnelle',
        value: null
      },
      { name: 'aeeh', label: 'Allocation d’éducation de l’enfant handicapé (AEEH) ',single:'une allocation d\'éducation de l’enfant handicapé (aeeh)', value: null },
      { name: 'asi', label: 'Allocation supplémentaire d’invalidité (ASI) ',single:'une allocation supplémentaire d’invalidité (asi)', value: null },
      { name: 'chomage_net', label: 'Allocations chômage (ARE) ',single:'une allocation chômage (are)', value: null },
      { name: 'af', label: 'Allocations familiales ', single:'des allocations familiales',value: null },
     // { name: 'paje_clca', label: 'Complément de libre choix d’activité (CLCA) ',single:'un complément de libre choix d\'activité (clca)', value: null },
      { name: 'caah', label: 'Complément de ressources adulte handicapé ',single:'un complément de ressources adulte handicapé', value: null },
      { name: 'cf', label: 'Complément familial (CF) ',single:'un complément familial (cf)', value: null },
      { name: 'mva', label: 'Majoration pour vie autonome (MVA) ',single:'une majoration pour vie autonome (mva)', value: null },
      { name: 'pch', label: 'Prestation de compensation du handicap (PCH) ', single:'une prestation de compensation du handicap (pch)', value: null },
      { name: 'paje', label: 'Prestation d’accueil du jeune enfant - Allocation de base ',single:'une prestation d\'accueil du jeune enfant (paje) - allocation de base', value: null },
      { name: 'paje_prepare', label: 'Prestation partagée d’éducation de l’enfant (PreParE) ',single:'une prestation partagée d\'éducation de l’enfant (prepare)', value: null },
      /*{
        name: 'prime_forfaitaire_mensuelle_reprise_activite',
        label: 'Prime forfaitaire mensuelle pour la reprise d’activité ',
        single:'une prime forfaitaire mensuelle pour la reprise d\'activité',
        value: null
      },*/
      { name: 'rsa', label: 'Revenu de solidarité active (RSA) ',single:'un revenu de solidarité active (rsa)', value: null }
    ]
  },

  indemnite: {
    name: 'indemnite',
    label: 'Indemnite',
    question: 'une indemnité ?',
    questionConjoint : "Votre conjoint perçoit-il une indemnité ?",
    info : 'Si vous percevez des indemnités maladies, indiquez les montants nets AVANT prélèvement à la source ou d\'éventuelles saisies.',
    ressources: [
      { name: 'dedommagement_victime_amiante', label: 'Dédommagement aux victimes de l’amiante',single:'un dédommagement aux victimes de l\'amiante', value: null },
      {
        name: 'indemnites_journalieres_maternite',
        label: 'Indemnités de maternité, paternité, adoption ',
        single:'des indemnités de maternité, paternité, adoption',
        value: null
      },
      { name: 'indemnites_volontariat', label: 'Indemnités de volontariat ',single:'des indemnités de volontariat', value: null },
      { name: 'indemnites_journalieres_accident_travail', label: ' Indemnités d’accident du travail ',single:'des indemnités d\'accident du travail', value: null },
      { name: 'indemnites_chomage_partiel', label: ' Indemnités d’activité partielle ',single:'des indemnités d’activité partielle', value: null },
      { name: 'indemnites_journalieres_maladie', label: 'Indemnités maladie ',single:'des indemnités maladie', value: null },
      {
        name: 'indemnites_journalieres_maladie_professionnelle',
        label: ' Indemnités maladie professionnelle ',
        single:'des indemnités maladie professionnelle',
        value: null
      }
    ]
  },

  pensions: {
    name: 'pensions',
    label: 'Pensions',
    question: 'une pension ?',
    questionConjoint : "Votre conjoint perçoit-il une pension ?",
    info : 'Si vous percevez une pension de retraite, indiquez les montants nets AVANT prélèvement à la source ou d\'éventuelles saisies.',
    ressources: [
      { name: 'pensions_alimentaires_percues', label: ' Pension alimentaire ',single:'une pension alimentaire', value: null },
      { name: 'pensions_invalidite', label: 'Pension d’invalidité ',single:'une pension d\'invalidité', value: null },
      { name: 'prestation_compensatoire', label: 'Prestation compensatoire (suite à séparation) ',single:'une prestation compensatoire (suite à séparation)', value: null },
      { name: 'retraite_brute', label: 'Retraite (y compris reversion), rente ',single:'une retraite (y compris reversion), rente', value: null },
      { name: 'retraite_combattant', label: 'Retraite du combattant ',single:'une retraite du combattant', value: null }
    ]
  },

  revenu_pro_non_salarie: {
    name: 'revenu_pro_non_salarie',
    label: 'Revenu professionel non salarié',
    question: 'un revenu professionel non salarié ?',
    questionConjoint : "Votre conjoint perçoit-il un revenu professionel non salarié ?",

    ressources: [
      { name: 'tns_auto_entrepreneur_chiffre_affaires', label: 'Auto-entrepreneur ou Micro-entreprise', value: null },
      { name: 'tns_benefice_exploitant_agricole', label: 'Exploitant agricole', value: null },
      { name: 'tns_autres_revenus', label: 'Profession libérale, entrepreneur ', value: null }
    ]
  },
  revenu_patrimoine: {
    name: 'revenu_patrimoine',
    label: 'Revenu du patrimoine',
    question: 'un revenu du patrimoine ?',
    questionConjoint : "Votre conjoint perçoit-il un revenu du patrimoine",

    ressources: [
      {
        name: 'revenus_capital',
        label: 'Revenus du capital (intérêts, plus-values, dividendes…) ',
        single:'un revenu du capital (intérêts, plus-values, dividendes…)',
        value: null
      },
      { name: 'revenus_locatifs', label: 'Revenus locatifs (terrains, appartements, SCI…) ',single:'des revenus locatifs (terrains, appartements, sci…)', value: null }
    ]
  },
  autres: {
    name: 'autres',
    label: 'Autres',
    question: "d'autres ressources ?",
    questionConjoint : "Votre conjoint perçoit-il d'autre ressources",

    ressources: [
      { name: 'bourse_enseignement_sup', label: "Bourse de l'enseignement superieur",single:'une bourse de l\'enseignement superieur', value: null },
      { name: 'bourse_recherche', label: 'Bourse de recherche',single:'une bourse de recherche', value: null },
      { name: 'gains_exceptionnels', label: 'Gains exceptionnels (dons, gains aux jeux , héritage)',single:'des gains exceptionnels (dons, gains aux jeux, heritage)', value: null }
    ]
  }
};

function getRessourcesNameFromType( type ) {
	return (listeRessources[type].ressources).map( (ress) => (ress.name));
}

function getAllRessourcesName () {
	var allRessources =[]; 
	Object.keys( listeRessources ).forEach( (typeRevenu) => {
			allRessources = [...allRessources, ...getRessourcesNameFromType(typeRevenu)];
		}
	)
	return allRessources;
}

function initialRessources(){
  var initialRessources ={};
  getAllRessourcesName().forEach( (ressName)=>{
      /* last 12 months date*/
      var ressource = {
        details : false,
        show:true,
      };
      var date = new Date();
      var year = (date.getFullYear()).toString();
      var yearMinOne = date.getFullYear()-1;
      var month = date.getMonth()+1;

      const revenu_pro_non_salarie = [
        'tns_auto_entrepreneur_chiffre_affaires',
        'tns_micro_entreprise_chiffre_affaires',
        'tns_autres_revenus',
        'tns_benefice_exploitant_agricole',
      ];

      if( !revenu_pro_non_salarie.includes(ressName)){
        for ( var i = 0 ; i < 48 ; i++ ) {
            let dateString = year + '-' + ('0' + month.toString()).slice(-2);
            ressource[dateString] = '';
            month = month - 1;
            if (month <= 0) {
              year -= 1;
              month = 12;
            }
            
          }
      } else {
        // Revenus professionnel non salarié .
        if (ressName === 'tns_auto_entrepreneur_chiffre_affaires') {

          ressource.type_activite = 'bic';
          ressource.continuation = false;
          ressource.opt_type_activite = [
            { value: 'achat_revente', label: 'Achat/revente ou fourniture de logement' },
            { value: 'bic', label: 'Autre activité relevant des BIC' },
            { value: 'bnc', label: 'Activité libérale et/ou intellectuelle (BNC)' }
          ];

          ressource[yearMinOne] = '';
        } else if (
          ressName === 'tns_micro_entreprise_chiffre_affaires' ||
          ressName === 'tns_autres_revenus'
        ) {
          ressource.type_activite = 'bic';
          ressource.opt_type_activite = [
            { value: 'achat_revente', label: 'Achat/revente ou fourniture de logement' },
            { value: 'bic', label: 'Autre activité relevant des BIC' },
            { value: 'bnc', label: 'Activité libérale et/ou intellectuelle (BNC)' }
          ];

          ressource[yearMinOne] = '';
        } else if (ressName === 'tns_benefice_exploitant_agricole') {
          ressource[yearMinOne] = '';
        }
      }
      initialRessources[ressName] = ressource;
    });
  return initialRessources;
}

var ressourcesList = [];
for (const key in listeRessources) {
  ressourcesList.push(...listeRessources[key].ressources);
}
const ressourcesFamille = [
          'asf',
          'aide_logement',
          'ppa',
          'cf',
          'af',
          'paje_base',
          'paje_prepare',
          'paje_clca',
          'aspa',
          'aeeh',
          'rsa',
          'paje',
        ];

export {listeRessources , getRessourcesNameFromType , getAllRessourcesName , initialRessources};
export {ressourcesList};
export {ressourcesFamille};